module.exports = __webpack_public_path__ + "static/img/banner-02.a311fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-02.png
// module id = F8fW
// module chunks = 1